export function CashOnDeliveryBadge({ isCashOnDelivery }: { isCashOnDelivery: boolean }) {
    const baseClasses = "text-[10px] font-semibold px-2 py-1 rounded-full uppercase tracking-wide";
    const codClasses = "bg-amber-100 text-amber-700 border border-amber-300";
    const noClasses = "bg-gray-100 text-gray-600 border border-gray-200 inline-block";

    return (
        <span className={`${baseClasses} ${isCashOnDelivery ? codClasses : noClasses}`}>
            {isCashOnDelivery ? "COD" : "NO"}
        </span>
    );
}
